<app-funnel-shell>
  <div class="funnel-card">
    <h1>{{ 'funnel.landing.title' | translate }}</h1>
    <p class="funnel-card__intro">{{ 'funnel.landing.subtitle' | translate }}</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <c-input-group class="mb-3">
        <span cInputGroupText><svg cIcon name="cilUser"></svg></span>
        <input
          cFormControl
          formControlName="first_name"
          type="text"
          [placeholder]="'funnel.landing.first_name_placeholder' | translate"
          [class.is-invalid]="firstNameCtrl().touched && firstNameCtrl().invalid"
          unassistedInput
        />
        @if (firstNameCtrl().touched && firstNameCtrl().invalid) {
          <c-form-feedback [valid]="false">
            {{ 'funnel.landing.first_name_required' | translate }}
          </c-form-feedback>
        }
      </c-input-group>

      <c-input-group class="mb-3">
        <span cInputGroupText><svg cIcon name="cilUser"></svg></span>
        <input
          cFormControl
          formControlName="last_name"
          type="text"
          [placeholder]="'funnel.landing.last_name_placeholder' | translate"
          unassistedInput
        />
      </c-input-group>

      <c-input-group class="mb-3">
        <span cInputGroupText><svg cIcon name="cilEnvelopeClosed"></svg></span>
        <input
          cFormControl
          formControlName="email"
          type="email"
          [placeholder]="'funnel.landing.email_placeholder' | translate"
          [class.is-invalid]="emailCtrl().touched && emailCtrl().invalid"
          unassistedInput
        />
        @if (emailCtrl().touched && emailCtrl().invalid) {
          <c-form-feedback [valid]="false">
            @if (emailCtrl().errors?.['required']) {
              {{ 'funnel.landing.email_required' | translate }}
            }
            @if (emailCtrl().errors?.['email']) {
              {{ 'funnel.landing.email_invalid' | translate }}
            }
          </c-form-feedback>
        }
      </c-input-group>

      <div class="mb-3">
        <div id="mcaptcha-widget"></div>
        @if (captchaError()) {
          <small class="text-danger">{{ 'funnel.landing.captcha_required' | translate }}</small>
        }
      </div>

      <button
        cButton
        color="primary"
        type="submit"
        class="w-100"
        [disabled]="!canSubmit()"
      >
        @if (loading()) {
          {{ 'funnel.landing.submitting' | translate }}
        } @else {
          {{ 'funnel.landing.submit' | translate }}
        }
      </button>

      @if (error()) {
        <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
      }

      @if (sponsorId()) {
        <p class="funnel-card__footnote">
          {{ 'funnel.landing.referred_by' | translate }}: <strong>#{{ sponsorId() }}</strong>
        </p>
      }
    </form>
  </div>
</app-funnel-shell>
